import {GameStrategy} from '../base/GameStrategy';
import {StaticData} from '../../../data/StaticData';
import {GameScene} from '../../../pixi_scene/GameScene';
import {TableController} from '../../../controllers/silent/TableController';
import {HandEvents} from '../../../pixi_scene/game_scene/hand/HandEvents';
import {TableObjectsEvents} from '../../../pixi_scene/game_scene/game_table/table_objects/TableObjectsEvents';

export class LoggedAfterGameStartedPlayerStrategy extends GameStrategy
{
    static handReset(): void {
        GameScene.hand.interactive = GameScene.hand.interactiveChildren = true;
        GameScene.hand.alpha = 1;
    }

    static tableObjectsReset(): void {
        TableController.table!.tableObjects!.interactive = TableController.table!.tableObjects!.interactiveChildren = true;
    }

    private static onHandUpdated(): void {
        GameScene.hand.interactive = GameScene.hand.interactiveChildren = false;
        GameScene.hand.alpha = .5;
    }

    private static onTableObjectsUpdated(): void {
        TableController.table!.tableObjects!.interactive = TableController.table!.tableObjects!.interactiveChildren = false;
    }

    private static removeListener(): void {
        removeEventListener(HandEvents.UPDATED, LoggedAfterGameStartedPlayerStrategy.onHandUpdated);
        removeEventListener(TableObjectsEvents.UPDATED, LoggedAfterGameStartedPlayerStrategy.onTableObjectsUpdated);
    }

    isApplicable(gameState: any): boolean {
        let automationPresents: boolean = gameState?.automation;
        let playerInGame: boolean = gameState?.automation?.playersMap?.[StaticData.playerId];
        let applicable:boolean = automationPresents && !playerInGame;
        console.warn('JustLoggedPlayer Strategy aplicable:', applicable);
        return applicable;
    }

    disable(): void {
        if(!this.running){
            return;
        }
        LoggedAfterGameStartedPlayerStrategy.removeListener();
        LoggedAfterGameStartedPlayerStrategy.handReset();
        LoggedAfterGameStartedPlayerStrategy.tableObjectsReset();
        super.disable();
    }

    execute(gameState: any): void {
        super.execute(gameState);
        console.warn('JustLoggedPlayer Strategy execute');

        addEventListener(HandEvents.UPDATED, LoggedAfterGameStartedPlayerStrategy.onHandUpdated);
        addEventListener(TableObjectsEvents.UPDATED, LoggedAfterGameStartedPlayerStrategy.onTableObjectsUpdated);

        LoggedAfterGameStartedPlayerStrategy.onHandUpdated();
        LoggedAfterGameStartedPlayerStrategy.onTableObjectsUpdated();
    }
}
